module.exports = __webpack_public_path__ + "img/FR11899.85e70969.png";